import React from "react";
import { SlideView as CoreView } from "@jelly/lesson";

import defaultStyle from "./SlideView.module.scss";

export const SlideView: React.FC<React.ComponentProps<typeof CoreView>> = (props) => {
  return <CoreView {...props} style={defaultStyle} />;
};
